/**
 * @module components\LeftMenu
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import store from '@/store';

@Component
export default class LeftMenu extends Vue {
  get staticData() {
    return store.getters.staticDataGet;
  }

  tabs = [];
  items: any = [];
  subTabs = [];

  get tabsData() {
    return this.staticData.payload.tabs;
  }

  get drawer() {
    return store.getters.userNavDataGet;
  }
  set drawer(val) {

  }
  get clientDetails() {
    return store.getters.updateSuperInitDataGet ? store.getters.updateSuperInitDataGet.payload2 ? store.getters.updateSuperInitDataGet.payload2[0] : null : null
  }

  leftIcons = {
    "CC": 'mdi-database',
    "CD": 'mdi-cash-100',
    'DASH': 'mdi-view-dashboard',
    'CLCM': 'mdi-list-box'
  };

  setItems() {
    if (this.tabs.includes('DASH')) {
      this.items.push(
        {

          icon: this.leftIcons['DASH'], text: this.tabsData.filter(el => { return el.key == 'DASH' })[0]['displayName'],
          path: 'dashboard'

        });
    }
    if (this.tabs.includes('CC')) {
      this.items.push(

        {
          icon: this.leftIcons['CC'],
          text: this.tabsData.filter(el => { return el.key == 'CC' })[0]['displayName'],
          model: false,

          children: [
            {
              text: 'Settlement Details',
              icon: 'mdi-text-box-multiple', activeTab: '', path: 'settlements', tab: 'CC', requestModule: 'SETTLEMENT'
            },
            { icon: 'mdi-history', text: 'Transaction History', path: 'txnHisCC', tab: 'CC', requestModule: 'HISTORY' }
          ],
        },
      );
    }
    if (this.tabs.includes('CD')) {
      const children = [];
      const cdTab = this.tabsData.find(el => el.key === 'CD');
      this.subTabs = cdTab ? cdTab.subTab : [];      
      if (this.subTabs != null) {
        this.subTabs.forEach(el => { 
        switch (el.subTabkey) {
            case 'UPLOAD':
                children.push({
                    icon: 'mdi-cloud-upload',
                    text: el.subTabDisplayName,
                    path: 'uploadCd',
                    tab: 'CD',
                });
                break;
            case 'VIEW':
                children.push({
                    icon: 'mdi-eye',
                    text: el.subTabDisplayName,
                    path: 'viewSr',
                    tab: 'CD',
                    requestModule: 'FILE_HISTORY'
                });
                break;
            case 'TRAN_HISTORY':
                children.push({
                    icon: 'mdi-history',
                    text: el.subTabDisplayName,
                    path: 'txnHisCD',
                    tab: 'CD',
                    requestModule: 'HISTORY'
                });
                break;
            case 'SR_STATUS':
                children.push({
                    icon: 'mdi-file-document-multiple',
                    text: el.subTabDisplayName,
                    path: 'srStatusCD',
                    tab: 'CD',
                    requestModule: 'SR_STATUS'
                });
                break;
            default:
                break;
        }
    });
      }
      this.items.push(
        {
          icon: this.leftIcons['CD'],
          text: this.tabsData.filter(el => { return el.key == 'CD' })[0]['displayName'],
          model: false,
          children: children
          // children: [
          //   { icon: 'mdi-cloud-upload', text: this.subTabs[0], path: 'uploadCd' },
          //   { icon: 'mdi-eye', text: 'View', path: 'viewSr', tab: 'CD', requestModule: 'FILE_HISTORY' },
          //   { icon: 'mdi-history', text: 'Transaction History', path: 'txnHisCD', tab: 'CD', requestModule: 'HISTORY' },
          //   { icon: 'mdi-file-document-multiple', text: 'SR Status', path: 'srStatusCD', tab: 'CD', requestModule: 'SR_STATUS' },
          // ]
        },
      );
    }
    if (this.tabs.includes('CLCM')) {
      this.items.push(
        {
          icon: this.leftIcons['CLCM'],
          text: this.tabsData.filter(el => { return el.key == 'CLCM' })[0]['displayName'],
          model: false,
          tab: 'CLCM',
          children: [
            { icon: 'mdi-history', text: 'Transaction History', path: 'txnHisCLCM', tab: 'CLCM', requestModule: 'HISTORY' },
            { icon: 'mdi-file-document-multiple', text: 'SR Status', path: 'srStatusCLCM', tab: 'CLCM', requestModule: 'SR_STATUS' },
          ],
        }

      );
    }

    if (this.tabs.includes('UPLOAD_MASTER')) {
      this.items.push(
        {
          icon: 'mdi-cloud-upload',
          text: this.tabsData.filter(el => { return el.key == 'UPLOAD_MASTER' })[0]['displayName'],
          model: false,
          tab: 'UPLOAD_MASTER',
          path: 'uploadMaster'
        }

      );
    }
    if (this.tabs.includes('DOWNLOAD_MASTER_DATA')) {
      this.items.push(
        {
          icon: 'mdi-arrow-down-bold',
          text: this.tabsData.filter(el => { return el.key == 'DOWNLOAD_MASTER_DATA' })[0]['displayName'],
          model: false,
          tab: 'DOWNLOAD_MASTER_DATA',
          path: 'downloadMaster'
       }
      );
    }  

    if (this.tabs.includes('USER_MGMT')) {
      this.items.push(
        {
          icon: 'mdi-account-multiple',
          text: this.tabsData.filter(el => { return el.key == 'USER_MGMT' })[0]['displayName'],
          model: false,
          tab: 'USER_MGMT',
          children: [
            { icon: 'mdi-cog-outline', text: 'Manage Users', path: 'manageUser', tab: 'USER_MGMT', requestModule: 'USER_MANAGEMENT' }]
        }
      );
    }
if (this.tabs.includes('UPLOAD_COMM')) {
      this.items.push(
        {
          icon: 'mdi-cash-edit',
          text: this.tabsData.filter(el => { return el.key == 'UPLOAD_COMM' })[0]['displayName'],
          model: false,
          tab: 'UPLOAD_COMM',
          children: [
            { icon: 'mdi-file-upload', text: 'Upload', path: 'uploadcomm', tab: 'UPLOAD_COMM', requestModule: 'COMMISION' },
            { icon: 'mdi-eye', text: 'Views', path: 'transhistory', tab: 'UPLOAD_COMM', requestModule: 'SMA_COMM' }]
        }
      );
    }

if (this.tabs.includes('COMMERCIALS')) {
      this.items.push(
        {
          icon: 'mdi-arrow-down-bold',
          text: this.tabsData.filter(el => { return el.key == 'COMMERCIALS' })[0]['displayName'],
          model: false,
          tab: 'COMMERCIALS',
          path: 'commercials'
        }
      );
    }
    // this.items.push(
    // {
    //   text: 'User Management',
    //   icon: 'mdi-account-multiple'
    // });


  }
  get superInitData() {
    return store.getters.updateSuperInitDataGet;
  }

  tabSelected = "";
  navigate(item) {
    this.tabSelected = item;
    if (item.tab) {
      store.dispatch('updateTabKeyAc', { 'tab': item.tab, 'requestModule': item.requestModule });
    }
    if (item.path) {
      let data = this.superInitData;
      data.dashboard = [];
      store.dispatch('updateSuperInitDataAc', data);
      this.$router.push({ name: item.path });
    }
    if (item.path == 'uploadMaster' || item.path == 'dashboard') {
      this.items.forEach(element => {
        if (element.children) {
          element.model = false;
        }
      });
    }
  }

  mounted() {
    this.staticData.payload.tabs.forEach(element => {
      this.tabs.push(element['key'])
    });
    
    this.setItems();
  }
}
